import * as Strategy from '#/unified-rfqs/ui/rfqs/strategy-functions';
import * as Product from '#/products/domain';
import { State } from '#/unified-rfqs/ui/rfq-builder/store';
import { isHedgeLeg, validateHedgeLegQuantity } from '../leg-functions';

export default function hedgeView(
  selectedStrategyCode: State['strategyCode'],
  legs: State['legs'],
  isOrderBook: boolean,
) {
  const isCustomStrategy = selectedStrategyCode == null;

  const productCode = legs[0]?.productCode;

  const isSupported =
    (isCustomStrategy || Strategy.supportsHedging(selectedStrategyCode)) &&
    Product.supportsHedging(productCode);

  if (!isSupported) return { isDisabled: true };

  if (!isOrderBook) {
    const hedgeLegs = legs.filter(isHedgeLeg);
    for (const hedgeLeg of hedgeLegs) {
      const { isValid, errorMsg } = validateHedgeLegQuantity(hedgeLeg);
      if (!isValid) return { isDisabled: false, submitMsg: errorMsg };
    }
  }

  if (isCustomStrategy) {
    return {
      isDisabled: false,
      errorMsg: getErrorMessage(legs),
    };
  }
  return { isDisabled: false };
}

function getErrorMessage(legs: State['legs']): string | undefined {
  const optionLegs = legs.filter((leg) => leg.kind === 'OPTION');

  if (optionLegs.length === 0) {
    return 'You must add at least one Option leg to add a future hedge leg.';
  }

  return undefined;
}
